<template>
    <div>
        <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                class="mydialog"
                :before-close="handleClose"
                center>
           <p style="text-align: center"> <span>{{this.message}}</span>&nbsp;<span><i class="el-icon-info"></i></span></p>
  <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="backhome">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>
        <script>
            export default{
                name:'Result',
                data(){
                    return{
                        centerDialogVisible:true,
                        message:''
                    }
                },
                methods:{
                    backhome(){
                        this.$router.push({name:'User',params:{}})
                    },
                    handleClose(done) {
                        this.backhome()
                    }
                },
                mounted:function(){
                    var type=this.$route.query.type
                    var _message=this.$route.query.message
                    switch (type){
                        case 'fail':
                                this.message='交易失败'
                            break;
                        case 'success':
                            this.message='交易成功'
                            break;
                        case 'busy':
                            this.message='服务器繁忙，请稍后再试'
                            break;
                        case 'other':
                            this.message=_message
                            break;
                    }
                }
            }
        </script>


// WEBPACK FOOTER //
// src/components/Result.vue